const en = {
	common: {
		'productIntroduction': 'Products',
		'cardPayment': 'Card Payment',
		'subscriptionPayments': 'Subscription Payments',
		'linkPayments': 'Payment Link',
		'bnpl': 'Buy Now, Pay Later',
		'dcc': 'Dynamic Currency Conversion',
		'checkoutDemo': 'Checkout Demo',
		'solutions': 'Solutions',
		'gamingSolutions': 'Digital Businesses ',
		'E-commerceSolutions': 'E-commerce Solutions',
		'resources': 'Resources',
		'integration': 'Integration Guide',
		'api': 'API Documentation',
		'FAQ': 'FAQ',
		'paymentMethods': 'Payment Methods',
		'login': 'Login',
		'contactUs': 'Contact Us',
		'support': 'Support',
		register: 'Sign Up Now',
		'about': 'About',
		'aboutUs': 'About Us',
		'newsCenter': 'News Center',
		'privacyPolicy': 'Privacy Policy',
		'emailSupport': 'Email Support',
		'socialMedia': 'Social Media',
		'cookie': 'Cookie Policy',
		copy: '© 2015–2025 All rights reserved. PingPong Global Solutions Inc. PingPong Payment Limited, PingPong Europe SA US NMLS ID:1572799 | UK Company Number 12602063 | EU Company Number B211775',
		customerSupport: 'Customer Support '

	},
	index: {
		title: 'PingPong Checkout',
		slogan: 'Borderless Payments, Limitless Possibilities ',
		desc1: 'Direct Access to Six Global Card Networks',
		desc2: 'Local Banking & PSP support',
		data1: 'Service Coverage & Regions',
		data2: 'Transaction Currency Coverage',
		data3: 'Global Licenses & Authorizations Acquired',
		data4: 'Cumulative TPV(USD) ',
		based: '*Data as of end of 2024',
		register: 'Sign Up Now',
		contactUs: 'Contact Us',
		globalText: 'Global Partners',
		payMethods: {
			title: `Supporting Global Preferred Payment Methods `,
			title1: 'Preferred Payment Methods',
			content: 'Access',
			number: '200+',
			content1: 'Global Payment Methods  ',
			content2: 'and Instantly Enhance Conversion Rates',
			label: 'Discover popular payment methods from around the world',
			more: 'Find payment methods'
		},
		solution: {
			slogan1: 'Diverse Payment Solutions',
			slogan2: 'Exceptional User Experiences',
			paynow: 'Pay Now',
			paynowDesc1: 'One-click, card-free payments across 6 global networks Boost checkout conversion rates',
			// paynowDesc2: 'Card-Free Payments, Boost Checkout Conversion Rates',
			more: 'Learn More',
			bnpl: 'BNPL',
			bnplDesc1: 'Buy Now, Pay Later with Peace of Mind',
			bnplDesc2: 'Flexible Installment Options to Choose From',
			subscription: 'Subscription',
			subscriptionDesc1: 'Link your card easily',
			subscriptionDesc2: ' Adjust payment cycles at anytime'
		},
		guard: {
			title: 'Comprehensive Protection for',
			title1: 'Your Business Lifeline',
			intelligent: 'Intelligent Payment',
			intelligentSubTitle: 'Smarter payments with higher conversion',
			intelligentDesc: 'Real-time analysis and intelligent routing to avoid congestion and risk points',
			intelligentDesc2: ' Automatic routing to avoid congestion and risk points',
			security: 'System Security',
			securitySubTitle: 'End-to-End Financial Security',
			based: "*Based on statistical data from PingPong's technical system",
			securityDesc1: 'PCI DSS + SOC2 Dual Certification Ensuring',
			securityDesc2: '99.99% System Stability',
			risk: 'Risk Prevention',
			riskSubTitle: 'Intelligent protection at every step',
			riskDesc1: 'Multi-layered Real-time Risk Control Protection Network',
			riskDesc2: 'Precise Identification of Abnormal Transaction Behavior Patterns',
			services: 'Professional Services',
			servicesSubTitle: '24/7 Expert Support',
			servicesDesc: 'Real-time, multi-layered risk control with precise transaction monitoring',
			servicesDesc2: 'Comprehensive Payment Solutions'
		},
		mode: {
			title: 'Three Integration Models',
			title1: ' to Jumpstart Your Online Payments',
			document: 'View Documentation',
			hosted: 'Hosted',
			hostedDesc: 'Zero-code payment deployment',
			hostedDesc1: 'All major payment methods auto-included',
			embedded: 'Embedded',
			embeddedDesc: 'Build your ideal payment interface',
			embeddedDesc1: 'Enhanced customer experience',
			api: 'API',
			apiDesc: 'Custom payment processing logic',
			apiDesc1: 'Supports complex business scenarios'
		},
		blog: {
			title: 'Global Payment Industry News',
			desc: 'Stay ahead with insights on emerging payment technologies ',
			desc1: 'and market trends that strengthen your business competitive edge.',
			more: 'Learn More'
		},
		faq: {
			title: 'FAQ',
			more: 'View more questions'
		},
		contactTitle: 'Start Your Global Payments Now'
	},
	cardPayment: {
		title: 'Card Payment',
		desc: 'Connecting Global Users Across Major Card Networks',
		// desc2: 'Major Local Card Networks, Covering Global Users',
		content: 'Supports the 6 major international card networks and major local card networks worldwide  ',
		// content2: `Covers major local card networks worldwide, such as China UnionPay, France's CB, Brazil's Elo, and more.`,
		support: 'Support Multiple payment scenarious ',
		increase: 'to develop your business globally',
		eCommerce: 'Cross-Border E-commerce',
		eCommerceDesc: 'One-click global collection for expansion across international markets',
		// eCommerceDesc1: 'helping merchants expand into international markets without barriers',

		game: 'Gaming Top-ups',
		gameDesc: 'Reduces costs and increases efficiency for various gaming payment scenarios',
		// gameDesc1: 'helping game merchants reduce costs and increase efficiency',
		ota: 'Education/AI and More',
		otaDesc: 'Applicable to more industries and payment needs',
		cardDesc1: 'Easy to Pay,Worry-Free Cross-Border Payments',
		cardDesc2: 'Worry-Free Cross-Border Payments',
		concactTitle: 'Start Your Card Payment Now'

	},
	subscriptionPayment: {
		desc1: 'Intelligent Recurring Subscriptions',
		desc2: 'for More Stable Revenue',
		content: 'Reduce churn with auto-retry Seamlessly manage and support all payment subscription types',
		// content2: 'Unified Management of Combined Subscriptions (Weekly/Monthly/Annual), Flexible Adjustments',
		support: 'Flexibly Matching Multiple Sales Models',
		stream: 'Stream  Subscriptions',
		streamDesc1: 'Real-time Card Expiration Monitoring',
		streamDesc2: 'Automatic Card Information Updates',
		membership: 'Membership Recharge',
		membershipDesc: 'Effortlessly auto-renew with flexible spend management Pause or cancel anytime',
		// membershipDesc2: '',
		saas: 'SaaS Services',
		saasDesc: 'Visual Subscription Package Configuration',
		saasDesc1: 'Automated Recurring Billing Management',
		step: {
			title: 'From One-Time Purchase to Long-Term Subscription',
			one: {
				title: 'Flexible Subscription Plans',
				desc: 'Convert single services into weekly/monthly/annual packages to match diverse user spending habits.'
			},
			two:	{
				title: 'Automatic Enrollment, Instant Retention',
				desc: 'Payment authorization completed automatically during checkout, no repeated steps required.'
			},
			three: {
				title: 'Auto-Renewal Management',
				desc: 'After initial successful payment, the system automatically processes renewals based on the selected cycle, with real-time alerts for payment exceptions.'
			}
		},
		concactTitle: 'Start Your Subscription Plan Now'

	},
	bnplPayment: {
		desc1: 'Boost revenue with Buy Now, Pay Later Services',
		// desc2: 'Installment Plans to Boost Revenue',
		content: 'Direct integration with leading global BNPL providers, reducing purchase barriers and enhancing conversion rates',
		salesGrowth: {
			title: 'Lower Price Barriers',
			title1: 'Boost Transaction Values',
			customerPrice: {
				title: 'Average Order Volume',
				desc: 'Increase Revenue by up to 15%*'
			},
			orderConversion: {
				title: 'High-Value Order Conversion Rate',
				desc: 'Increase Revenue by up to 10%*'
			},
			industryPreference: {
				title: 'Effectively Target Industries',
				desc: 'Essential for Electronics, Beauty, Fashion, and Home Goods'
			},
			based: "*Based on PingPong's internal customer statistics"
		},
		step: {
			title: 'Buy Now, Pay Later, Zero Wait',
			// title1: 'Buy Now, Pay Later with Zero Wait',
			one: {
				title: 'Choose Your Installment Plan',
				desc: 'Flexible options including BNPL and various installment payment solutions.'
			},
			two: {
				title: 'One-Click Credit Approval',
				desc: 'Link/login to your BNPL account for instant credit assessment.'
			},
			three: {
				title: 'Complete the Transaction',
				desc: 'Once the customer confirms the purchase, merchants receive the full payment instantly.'
			}

		},
		concactTitle: 'Start Your BNPL Now'

	},
	linkPayment: {
		title: 'Payment Link',
		desc: ' Creat payment link to help your business',
		// desc2: 'and Secure Global Payments',
		content1: 'Instant, no-code setup with Multi-payments ',
		content2: 'to accept your business payments',
		support: 'Multiple Scenarios Available ',
		support1: 'Generate Instant Payments with One Click',
		customer: 'Live Support',
		customerDesc1: 'Allow online customer service team to send out the payment link ',
		customerDesc2: 'to your clients and get the payments directly',
		media: 'Social Media',
		mediaDesc: 'One-click sharing, allowing followers to pay without redirection',
		mediaDesc2: 'to pay without redirection',
		email: 'Email and SMS',
		emailDesc: 'Send payment link with one click, improving converstion rates',
		emailDesc1: 'that can be sent with one click to improve payment conversion rates',
		step: {
			title: 'No Code Required, Multi-Channel Collection, ',
			title1: ' Effortlessly Expand Your Business',
			one: {
				title: 'Create Payment Links',
				desc: 'Create professional payment links and branded QR codes, supported for one-time payment or long-term use.'
			},
			two: {
				title: 'Share Payment Links',
				desc: 'Share links or QR codes via email, social media, SMS, and more. Also available to embed in branded invoices.'
			},
			three: {
				title: 'Complete Collections',
				desc: 'Track payments in real time with a live dashboard. Simplify cash flow while supporting steady business growth.'
			}

		},
		concactTitle: 'Start Your Payment Link Now'

	},
	dcc: {
		desc: 'Dynamic Currency Conversion, Clear Pricing, and Secure Checkout',
		desc2: 'More Transparent Pricing, More Secure Payments',
		content: 'Automatically convert 80+ currencies at checkout with local payment options, transparent FX, and unified global pricing.',
		support: 'Easily Implement Local Currency Pricing',
		support1: 'to Effectively Enhance Payment Experience',

		habit: 'Aligns with Consumer Habits',
		habitDesc1: "Local currency pricing better aligns with overseas consumers' spending habits.",
		time: 'Reduces Decision-Making Time',
		timeDesc: 'Local currency pricing removes guesswork and manual calculations, helping customers decide faster.',
		timeDesc2: 'shortening purchase decision time',
		rate: 'Improves Order Conversion Rate',
		rateDesc: 'Local currency pricing increases order conversion rates by 5% on average, compared to foregin currency pricing*.',
		rateDesc1: ' increases order conversion rates by an average up to 5% compared to foreign currency pricing*',
		based: "*Based on PingPong's internal customer statistics",
		step: {
			title: 'DCC Enables Businesses ',
			title1: 'to Easily Manage Order Exchange Rates',
			one: {
				title: 'Lock Exchange Rates to Meet Various Duration Requirements',
				desc: "Meets different businesses' needs for order exchange rate locking periods, effectively extending consumer transaction intent."
			},
			two: {
				title: 'Support Dual Currency Selection, Allowing Customers to Choose',
				desc: 'Supports automatic identification of local currency based on card BIN, allowing consumers to choose between local or foreign currency transactions.'
			},
			three: {
				title: 'Manage Currency Risks with Transparent Exchange Rates',
				desc: 'Businesses can obtain exchange rates before transactions, allowing them to evaluate conversion costs in advance and effectively manage foreign exchange risks.'
			}

		},
		concactTitle: 'Start Your Dynamic Currency Converstion Now'
	},
	eCommerce: {
		introduce: {
			desc: 'Supporting Global E-commerce',
			desc1: 'Multi-scenario Payment Solutions',
			content: 'Supports various website types, including independent sites, marketplaces, SaaS platforms, and open-source systems'
		},
		experience: {
			title1: 'Minimalist E-commerce Checkout',
			title2: 'Optimized Payment Experience',
			one: {
				title: 'Global Sales',
				desc: "Automatically adapt to global buyers' languages and devices with support for international payment methods. Create a samless checkout expereince that reduces cart abandonment."
			},
			two: {
				title: 'Custom Style',
				desc: 'Create consistent styling between checkout and brand identity with personsalized options.'
			}
		},
		methods: {
			title1: 'Multiple Payment Solutions ',
			title2: 'to Ensure Order Conversion',

			one: {
				title: 'Flexible Credit Card Products',
				desc: 'Enable one-time charges, card-on-file payments, and installment plans based on customer preferences.'
			},
			two: {
				title: 'Diverse Localized Payment Solutions',
				desc: 'Align regional consumer habits with various online local payment methods.'
			},
			three: {
				title: 'Multiple BNPL Credit Products',
				desc: 'We support consumers using safe and reliable Buy Now Pay Later products to lower purchase barriers.'
			}
		},
		currency: {
			title1: 'Multi-currency settlement with seamless USD inbound support',
			// title2: 'enabling seamless RMB inbound transfers',

			desc: 'Licensed for both domestic and international payment services, supporting settlement in major currencies including USD, EUR, JPY and CNY'
		},
		concactTitle: 'Learn About Our E-Commerce Solutions Now'
	},
	gaming: {
		introduce: {
			desc: 'Supporting Multi-scenario Payment Solutions',
			desc1: 'for Global Game Publishers'
		},
		scene: {
			one: {
				title: 'Works on All Devices',
				desc: 'Supports multiple gaming platforms, including PC and mobile games.'
			},
			two: {
				title: 'Flexible charging models',
				desc: 'Supporting different paid products such as game items and membership subscriptions.'
			},
			three: {
				title: 'Marketing Strategies',
				desc: 'Support for various game marketing campaigns to increase gaming revenue.'
			}
		},
		payType: {
			title1: 'Supporting Multiple Payment Types',
			title2: ' to Meet Different Consumer Preferences',
			card: {
				title: 'Credit Card Payments',
				desc: 'Supports all six major global card networks'
			},
			mobile: {
				title: 'Mobile Payments/E-Wallet Payments',
				desc: 'Supports Apple Pay, Google Pay, and all major electronic wallets in various countries'
			},
			prepaid: {
				title: 'Prepaid Card Payments',
				desc: 'Supports Paysafecard and other prepaid cards, allowing customers to pay without a bank account'
			},
			carrier: {
				title: 'Carrier Billing',
				desc: 'Maximize mobile game revenue with carrier-based payments'
			}
		},
		marketing: {
			title: 'Supports a Variety of Marketing Activities',
			desc: 'Achieving up to 20% Revenue Growth*',
			discount: 'Game product discount configurations',
			payDiscount: 'Random discounts during the payment process',
			orderDiscount: 'Order-based discount promotions',
			appDiscount: 'Exposure through international payment apps',
			based: "*Based on PingPong's internal customer statistics"

		},
		concactTitle: 'Learn About Our Digital Businesses  Solutions Now'
	},
	contactUs: {
		globalization: 'Empower Business Globalization with Superior Payment Solutions',
		solutions: ' Providing Superior Global Payment Solutions',
		name: 'Name',
		nameRule: 'This field is required. Enter a valid name between 2-30 characters with alphanumeric characters',
		email: 'Business Email',
		emailRule: 'This field is required. Enter a valid email address example@domain.com',
		phone: 'Phone number',
		phoneRule: 'This field is required. Please enter a correct mobile number.',
		company: 'Company Name',
		companyRule: 'This field is required. Enter a valid name between 2-30 alphanumeric characters.',
		link: 'Company Website/Product Link',
		linkRule: 'This field is required. Enter a valid URL (e.g., https://www.pingpongx.com).',
		agreement1: 'I agree that PingPong will process my information in accordance with the',
		agreement2: 'Privacy Policy.',
		agreement3: 'The above information will only be used to authorize PingPong to send me product and event information.',
		sales: 'Get in touch',
		submitSuccess: 'Submission Successful',
		thank: 'Thank you for your submission. We will contact you as soon as possible.',
		close: 'Close'
	},
	cookiePolicy: {
		title: 'PingPong Cookie Policy',
		date: 'Last updated May 2025',
		desc1: 'Thank you for choosing PingPong (as defined in our <a href=https://www.pingpongx.com/zh/termsandConditions?channel=bing&inviteCode=ac-18&utm_source=bing-PC&utm_medium=pin-pai-ci-PC&utm_campaign=he-xin-ci&utm_term=pingpong&msclkid=1b12a230bf3b1f5f9a5cca1bb547799a&cb=true target=_blank> Terms and Conditions</a>). We are committed to protecting your personal information and your right to privacy, and we take your privacy very seriously. “You” in this Cookie Policy refers to any users or visitors to any of our websites or applications upon which this policy is displayed (each a “Site” and together the “Sites”).',
		desc2: "This Policy describes what cookies and other similar (e.g., tracking) technologies, such as pixels or SDKs, (collectively “Cookies”) are used on our Sites and how they're being used. Cookies can collect personal information and therefore we encourage to you read our Privacy Policy for further information on how we use, store and keep your personal information secure.",
		section1: {
			title: 'What are Cookies?',
			desc: 'Cookies are simple text files that are saved on your computer or other devices, such as your mobile phone, when you visit one of our Sites. This allows our Sites to recognize your device from those of other users of the Sites.',
			desc1: 'Cookies can be differentiated as “first-party” and “third-party” Cookies and both types of Cookies are used on our Sites. “First-party” Cookies are set by us on our Sites. Only our Sites can read them. and “third-party” Cookies are set by third parties who provide services such as advertising and analytics on our Sites. These third parties may collect your device ID, IP address, or other information about your use of the Sites as part of the analytics they provide to us. To view how third parties collect and use your data, please visit:',
			google: '<a href="https://policies.google.cn/technologies/partner-sites?hl=en" target="_blank">https://policies.google.cn/technologies/partner-sites?hl=en</a>'
		},
		section2: {
			title: 'Do we need your consent for cookies?',
			desc: 'We will collect your consent to place cookies on your device, except in certain circumstances where cookies are essential for the transmission of a communication, or when cookies are strictly necessary for us to provide you with a service you have requested.',
			desc1: 'You can withdraw your consent to the use of cookies or adjust your cookie preferences by going to the Privacy Preference Center accessible at the bottom of the page at any time. Please note that you may need to refresh your page for your settings to take effect.'
		},
		section3: {
			title: 'What type of cookies do we use?',
			desc: 'Every time you visit our Sites, you will be prompted to accept or refuse cookies. The purpose is to enable the Sites to remember your preferences (such as user name, language, etc.) for a certain period of time. That way, you do not have to re-enter them when browsing around the site during the same visit.',
			desc1: 'Cookies can be categorized by general types.',
			table: {
				column: {
					title1: 'Cookie Type',
					title2: 'Purpose'
				},
				data: [{
					type: 'Essential',
					purpose: 'Essential Cookies are those strictly necessary for us to provide and operate the Sites and cannot be deactivated or rejected by users without affecting the functioning of the site and its use. Without these cookies, you would not be able to navigate between pages or use certain essential functions of the Sites.'
				},
				{
					type: 'Functional',
					purpose: 'Functional Cookies enable us operate the Sites in accordance with the choices you make. For example, Functionality Cookies remember your settings such as your language preferences.  '
				},
				{
					type: 'Analytical',
					purpose: 'Analytical Cookies enable us and third-party services to collect aggregated data for statistical purposes on how our visitors use our website. '
				},
				{
					type: 'Targeting',
					purpose: 'Targeting Cookies enable us to ensure advertising is more tailored to you.'
				}]
			}
		},
		'section4-1': {
			title: 'Essential Cookie',
			table: {
				column: {
					title1: 'Cookie Name',
					title2: 'Description',
					title3: 'Duration',
					title4: 'Domain',
					title5: 'First Party or Third Party Cookie'
				},
				data: [
					{
						name: 'fs_merchant',
						description: 'This cookie is used for S3 file upload verification, allowing users to upload files when authorized.',
						duration: '24 hours',
						domain: ['.pingpongx.com'],
						firstOrThirdParty: 'First Party'
					}
				]
			}
		},
		section4: {
			title: 'Functional Cookies',
			table: {
				column: {
					title1: 'Cookie Name',
					title2: 'Description',
					title3: 'Duration',
					title4: 'Domain',
					title5: 'First Party or Third Party Cookie'
				},
				data: [

					{
						name: 'vuepack',
						description: 'This cookie is used to record user multilingual settings information',
						duration: 'Temporary Session',
						domain: ['.pingpongx.com'],
						firstOrThirdParty: 'First Party'
					},
					{
						name: 'Site',
						description: 'This cookie is used to record information about the sites that the user is currently visiting',
						duration: 'Temporary Session',
						domain: ['.pingpongx.com'],
						firstOrThirdParty: 'First Party'
					}, {
						name: '_SIGNUP',
						description: 'This cookie is used to r ecord the location information selected by the user during registration.',
						duration: 'Temporary Session',
						domain: ['.business.pingpongx.com'],
						firstOrThirdParty: 'First Party'
					}, {
						name: '_gid',
						description: 'This cookie is used for official website address source record.',
						duration: 'Long term',
						domain: ['.pingpongx.com'],
						firstOrThirdParty: 'First Party'
					}, {
						name: 'Optanon Consent',
						description: 'This cookie is used to store users’ consent choices and preference settings for website cookie usage.',
						duration: 'Long term',
						domain: ['vn.pingpongx.com',
							'bd.pingpongx.com',
							'id.pingpongx.com',
							'th.pingpongx.com',
							'kr.pingpongx.com',
							'international.pingpongx.com'],
						firstOrThirdParty: 'Third  Party'
					}
				]
			}
		},
		section5: {
			title: 'Analytical Cookies',
			table: {
				column: {
					title1: 'Cookie Name',
					title2: 'Description',
					title3: 'Duration',
					title4: 'Domain',
					title5: 'First Party or Third Party Cookie'
				},
				data: [
					// {
					// 	name: 'acw_tc',
					// 	description: 'This cookie is used to collect user device information for the purpose of recording user’s behavioral data.',
					// 	duration: '30 minutes',
					// 	domain: ['.logbury.pingpongx.com'],
					// 	firstOrThirdParty: 'First Party'
					// },
					{
						name: '_ga',
						description: 'This cookie is used for Facebook tracking and analytics.',
						duration: 'Long term',
						domain: ['.pingpongx.com'],
						firstOrThirdParty: 'Third Party'
					},
					{
						name: '_gcl_au',
						description: 'This cookie is used for Facebook tracking and analytics.',
						duration: 'Long term',
						domain: ['.pingpongx.com'],
						firstOrThirdParty: 'Third Party'
					}, {
						name: 'ar_debug',
						description: 'This cookie is used for Google tracking and analytics',
						duration: 'Long term',
						domain: ['.pingpongx.com'],
						firstOrThirdParty: 'Third Party'
					}, {
						name: '_bl_uid',
						description: 'This cookie is Aliyun ARMS, used  for front-end performance monitoring and troubleshooting (to be deprecated in upcoming versions)',
						duration: 'Long term',
						domain: ['.business.pingpongx.com'],
						firstOrThirdParty: 'Third Party'
					}, {
						name: '_fwb',
						description: 'This cookie is used for NAVER Web Traffic Analytics Service.',
						duration: 'Long term',
						domain: [`.business.pingpongx.com`],
						firstOrThirdParty: 'Third  Party'
					}
					// {
					// 	name: 'acw_tc',
					// 	description: 'This cookie is used for company internal tracking and analytics.',
					// 	duration: 'Long term',
					// 	domain: [`.pingpongx.com`],
					// 	firstOrThirdParty: 'Third  Party'
					// }
				]
			}
		},
		section6: {
			title: 'How can you manage cookies?',
			desc: 'You have full control over cookies when you use Our website. You have the following options to control or limit how we and our third-party partners use Cookies:',
			list: [{
				title: 'Browser and device:',
				desc: 'Disable your Cookies through your browser and device settings. You can delete all cookies that are already on your device by clearing the browsing history of your browser. This will remove all cookies from all Sites you have visited.. If you disable cookies, however, some of the features of our Services may not function properly. Below are links to Cookie manage pages for common web browsers. If your browser is not listed here, you should review the web browser terms for more information:',
				items: [
					{
						name: 'Google Chrome：',
						link: '<a href=https://support.google.com/chrome/answer/95647?hl=en target=_blank >https://support.google.com/chrome/answer/95647?hl=en</a>'
					},
					{
						name: 'Apple Safari：',
						link: '<a href=https://support.apple.com/en-gb/guide/safari/sfri11471/mac target=_blank >https://support.apple.com/en-gb/guide/safari/sfri11471/mac</a>'
					},
					{
						name: ' Mozilla Firefox：',
						link: '<a href=https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox target=_blank >https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox</a>'
					},
					{
						name: 'Microsoft Edge：',
						link: '<a href=https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies target=_blank >https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies</a>'
					}
				]
			}, {
				title: 'EU and UK users: ',
				desc: 'Before non-Essential Cookies are set on our Sites, we will ask for your consent to do so through our Privacy Preference Center.  If you do not wish to provide your consent for all Cookies, you should click [“Reject All”], or if you would like to provide your consent for some but not all Cookies, you should click [“Confirm My Choices”].  If you would like to accept all Cookies, you should click [“Allow All”].'
			}],
			desc1: 'For more information with respect to your rights, please see our <a href=https://www.pingpongx.com/zh/privacyPolicy?cb=true  target=_blank>Privacy Policy.</a> '
		},
		section7: {
			title: 'Changes and amendments',
			desc: 'We may update this Cookie Policy from time to time. The updated version will be indicated by an updated “Last Updated” date above and the updated version will be effective as soon as it is accessible. If we make material changes to this Cookie Policy, we may notify you either by prominently posting a notice of such changes or by directly sending you a notification. We encourage you to review this Cookie Policy frequently to be informed of how we are using Cookies. '
		},
		section8: {
			title: 'Contact us',
			desc: 'If you reside anywhere outside of the European Economic Area (EEA) and the United Kingdom, you may contact us by email at  <a href="mailto:service@pingpongx.com">service@pingpongx.com</a>.',
			desc1: 'If you reside in the European Economic Area, you may contact our Data Protection Officer (DPO) by email at <a href="mailto:dpo-uk@pingpongx-uk.com">dpo@pingpongx-eu.com</a>, or by post to:',
			european: [
				'PingPong Europe SA', 'Data Protection Department', 'Rue du Laboratoire 9 ', 'L-1911 Luxembourg'
			],
			desc2: 'If you reside in the United Kingdom, you may contact our Data Protection Officer (DPO) by email at  <a href="mailto:dpo-uk@pingpongx-uk.com">dpo-uk@pingpongx-uk.com</a>, or by post to:',

			uk: [
				'PingPong Payments (UK) Limited', 'Data Protection Department', '78 Cannon Street, London, England EC4N 6HL,', 'United Kingdom'
			]

		}

	}
}
export default en
